import { render, staticRenderFns } from "./master-liability-table1.vue?vue&type=template&id=5bca6bb2&"
import script from "./master-liability-table1.vue?vue&type=script&lang=js&"
export * from "./master-liability-table1.vue?vue&type=script&lang=js&"
import style0 from "./master-liability-table1.vue?vue&type=style&index=0&id=5bca6bb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports